import React, { useState } from "react";
import PropTypes from "prop-types";
import { I18n } from "@aws-amplify/core";
import { get, forEach } from "lodash";

import Grid from "@material-ui/core/Grid";

import CustomInput from "../../Common/CustomInput";
import CustomSelect from "../../Common/CustomSelect";
import CustomButton from "../../Common/CustomButton";
import Note from "../../Common/Note.js";
import Loader from "../../Common/Loader";

import { fetchPost } from "../../../api/fetch";

import { formatDate } from "../../../utils/date";
import { isUnknownProfile } from "../../../utils/profile";
import { getUser } from "../../../utils/users";

import {
  human,
  driver,
  truck,
  trailer1,
  trailer2,
  container1,
  container2,
} from "../../../constants/common";

import images from "../../../assets/img/images";
import { getNoteType } from "../../../utils/noteType";

const LogDetailsNotes = (props) => {
  const { notes, eventGroupIds } = props;
  const [editMode, setEditMode] = React.useState(false);
  const [authors, setAuthors] = React.useState({});
  const [newNoteDesc, setNewNoteDesc] = React.useState("");
  const [newNoteAbout, setNewNoteAbout] = React.useState("main");
  const [noteTypeOptions,setNoteTypeOptions]=React.useState([]);
  const [noteType, setNoteType] = React.useState(1);
  React.useEffect(() => {
    const fetchAuthors = async () => {
      let res = {};
      let allNotes = getAllNotes();
      for (let i = 0; i < allNotes.length; i++) {
        if (
          allNotes[i].updated_by &&
          !authors[allNotes[i].updated_by] &&
          !res[allNotes[i].updated_by]
        ) {
          try {
            let author = await getUser(allNotes[i].updated_by);
            res[allNotes[i].updated_by] =
              author.profile.firstname + " " + author.profile.lastname;
          } catch (e) {
            console.log(e);
          }
        }
      }
      if (Object.keys(res).length > 0) {
        setAuthors({
          ...authors,
          ...res,
        });
      }
    };
    fetchAuthors();
    const fetchNoteType= async()=>{
      let value =await getNoteType()
      setNoteTypeOptions(value)
    }

    fetchNoteType()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  const saveNote = async () => {
    setEditMode(false);
    try {
      let id = props.eventGroupIds[newNoteAbout];
      let note = {
        description: newNoteDesc,
        sys_note_type_id:noteType
      };

      if (
        !isUnknownProfile(get(props, ["log", newNoteAbout, "profile", "id"]))
      ) {
        note.profile_id = get(props, ["log", newNoteAbout, "profile", "id"]);
      }

      let newNote = await fetchPost(`event_groups/${id}/notes`, note);
      props.addNote({ ...newNote, related: newNoteAbout });
    } catch (e) {
      console.log(e);
    }
    setNewNoteDesc("");
  };

  const getAllNotes = () => {
    return [
      ...notes.main.map((n) => ({ related: "main", ...n })),
      ...notes.human.map((n) => ({ related: human, ...n })),
      ...notes.driver.map((n) => ({ related: driver, ...n })),
      ...notes.truck.map((n) => ({ related: truck, ...n })),
      ...notes.trailer1.map((n) => ({ related: trailer1, ...n })),
      ...notes.trailer2.map((n) => ({ related: trailer2, ...n })),
      ...notes.container1.map((n) => ({ related: container1, ...n })),
      ...notes.container2.map((n) => ({ related: container2, ...n })),
    ];
  };

  const getAvailableAboutOptions = () => {
    let options = [];
    forEach(eventGroupIds, (value, type) => {
      if (value) {
        options.push({
          id: type,
          name: I18n.get(`site_${type}`),
        });
      }
    });
    return options;
  };
  const getNoteTypeValue=(id)=>{
    for(let val of noteTypeOptions){
      if(val.id===id) return val.name
    }
    return ""
  }

  if (props.loading) {
    return (
      <Grid
        container
        alignItems="center"
        justify="center"
        style={{ height: "-webkit-fill-available" }}
      >
        <Grid item>
          <Loader message={I18n.get("common_loading")} noDecoration />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid
      container
      direction="column"
      style={{
        //marginLeft: "24px",
        width: "650px",
        padding: "21px",
        paddingTop: "0px",
      }}
    >
      <Grid item>
        <CustomButton
          variant="contained"
          color="primary"
          disabled={editMode}
          startIcon={
            <img
              src={editMode ? images.plusIconDarkGrey : images.plusIconWhite}
              alt="plus"
            />
          }
          onClick={() => setEditMode(true)}
          style={{ marginBottom: "20px" }}
        >
          {I18n.get("common_new")}
        </CustomButton>
      </Grid>
      {editMode && (
        <>
        <Grid container spacing={8}>
          <Grid item style={{ marginBottom: "10px" }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item className="text-54">
                {I18n.get("site_noteAbout")}
              </Grid>
              <Grid item style={{ width: "200px" }}>
                <CustomSelect
                  name="noteAbout"
                  value={newNoteAbout}
                  onChange={(e) => setNewNoteAbout(e.target.value)}
                  options={getAvailableAboutOptions()}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item style={{ marginBottom: "10px" }}>
            <Grid container spacing={2} alignItems="center">
              <Grid item className="text-54">
                {I18n.get("site_noteType")}
              </Grid>
              <Grid item style={{ width: "200px" }}>               
                <CustomSelect
                  name="noteType"
                  value={noteType}
                  onChange={(e) => setNoteType(e.target.value)}
                  options={noteTypeOptions}
                />
              </Grid>
            </Grid>
          </Grid>
          </Grid>
          <Grid item> 
            <CustomInput
              name="description"
              value={newNoteDesc}
              onChange={(e) => setNewNoteDesc(e.target.value)}
              multiline={true}
              rows={5}
            />
          </Grid>
          <Grid item style={{ textAlign: "right" }}>
            <CustomButton
              color="primary"
              style={{ margin: "10px 10px 0px 0px" }}
              onClick={() => setEditMode(false)}
            >
              {I18n.get("site_cancel")}
            </CustomButton>
            <CustomButton
              variant="contained"
              color="primary"
              style={{ margin: "10px 0px 0px 0px" }}
              disabled={newNoteDesc ? false : true}
              onClick={saveNote}
            >
              {I18n.get("site_save")}
            </CustomButton>
          </Grid>
        </>
      )}
      {getAllNotes()
        .sort(
          (a, b) =>
            new Date(b.updated_on).getTime() - new Date(a.updated_on).getTime()
        )
        .map((note) => (
          <Grid item key={note.id}>
            <hr
              style={{
                borderLeft: "none",
                margin: "25px",
                color: "black",
                opacity: "0.3",
              }}
            />
            <Note
              author={authors[note.updated_by] || ""}
              related={note.related}
              date={formatDate(note.updated_on)}
              description={note.description}
              noteType={getNoteTypeValue(note.sys_note_type_id)}
            />
          </Grid>
        ))}
    </Grid>
  );
};

LogDetailsNotes.propTypes = {
  notes: PropTypes.object.isRequired,
  addNote: PropTypes.func,
  loading: PropTypes.bool,
  eventGroupIds: PropTypes.object.isRequired,
};

export default LogDetailsNotes;
